
import { Component, Vue } from "vue-property-decorator";
import Template from "@/views/system-management/template/index.vue";
import { Message } from "element-ui";
import {
  getInquirySheetTableHeader,
  getQuoteLibraryTableHeader,
  updateInquirySheetTableHeader,
  saveRFQ,
  uploadDynamicsExcel,
  queryTaskInfo,
} from "@/api/product-business";

import { deleteInquirySheet } from "@/api/inquiry"

import { getCNTableHeader } from "@/api/credit-note";
import { searchCustomer } from "@/api/customer";
import { ICustomerModel } from "@/api/types";
import { getOrderLibraryTableHeader } from "@/api/order-library";
import { getClaimFormCNCode } from "@/api/credit-note";

@Component({
  name: "formUploadTool",
  components: { Template },
})
export default class extends Vue {
  private checked1 = false;
  private checked2 = false;

  private saveProductNumberExtends = false;
  private clearProductNumberExtends = false;
  private files: any[] = [];
  private drawer = false;
  private taskId = "";
  private isSearchingCustomers = false;
  private customers: ICustomerModel[] = [];
  // 需要选择的头
  private headerList: [] = [];
  // 返回后端的头
  private requestHeader: string[] = [];
  // 去重后的表头
  private realHeader: string[] = [];
  private resultHeaderList: any[] = [];
  private chooseHeader: any[] = [];

  private headerMap = new Map<string, string>();
  private importantMessage: any = "";
  private rulesItem = [] as any;
  private saveButtonDisabled = false;
  private accountTypeByOperation;

  private payload = {
    type: "inquiryLibrary",
    item: "",
    customerId: "",
    replace: false,
    IVterm: "",
    PIterm: "",
    CNCode: "",
  };

  // 第一行表头
  private dataHeader: TableHeadler = new TableHeadler();

  private linkEvent: any = "";
  private linkMessage: any = "";

  // 第一行数据
  private rowData = [];

  private documentTypes = [] as any;
  private documentTypesOfAll = [
    { value: "inquiryLibrary", label: "询价单" },
    { value: "updateInquirySheet", label: "维护询价单" },
    { value: "quoteLibrary", label: "报价库" },
    { value: "orderLibrary", label: "下单库" },
    { value: "claimForm", label: "索赔单" },
  ];

  private IVterm = [
    { value: "halfYear", label: "半年" },
    { value: "oneYear", label: "一年" },
    { value: "twoYear", label: "二年" },
    { value: "noLimit", label: "不限" },
  ];

  private PIterm = [
    { value: "halfYear", label: "半年" },
    { value: "oneYear", label: "一年" },
    { value: "twoYear", label: "二年" },
    { value: "noLimit", label: "不限" },
  ];

  private CNCode = [];

  async destroyed() {
    // debugger
    console.log('窗口关闭')
    // const res: any = await deleteInquirySheet(180006701087473664);
  }

  created() {
    this.drawer = false;
    if(this.$route.query.updateExtendsOptionsCode) {
      if(this.$route.query.updateExtendsOptionsCode === '1'){
        this.clearProductNumberExtends = false,
        this.saveProductNumberExtends = false
      } else if(this.$route.query.updateExtendsOptionsCode === '2') {
        this.clearProductNumberExtends = false,
        this.saveProductNumberExtends = true
      } else if(this.$route.query.updateExtendsOptionsCode === '3') {
        this.clearProductNumberExtends = true,
        this.saveProductNumberExtends = true
      }
    }
    if(this.$route.query.accountTypeOperation) {
      this.accountTypeByOperation = Array.isArray(this.$route.query.accountTypeOperation) ?
      this.$route.query.accountTypeOperation[0]:this.$route.query.accountTypeOperation;
    }
    if (this.$route.query.type) {
      let newLabel =
        this.documentTypesOfAll[
          this.documentTypesOfAll.findIndex(
            (e) => e.value === this.$route.query.type
          )
        ].label;
      this.documentTypes = [{ value: this.$route.query.type, label: newLabel }];
      this.payload.type = this.$route.query.type as any;
      if (this.$route.query.type === "claimForm") {
        this.getClaimFormCNCode();
      }
    } else {
      this.documentTypes = [
        { value: "quoteLibrary", label: "报价库" },
        { value: "orderLibrary", label: "下单库" },
      ];
      this.payload.type = "";
    }
    this.payload.replace = (this.$route.query.replace as string) === "true";
    this.customerName();
    // this.getClaimFormCNCode();
    this.assignmentOfMessage();
  }

  private assignmentOfMessage() {
    switch (this.payload.type) {
      case "inquiryLibrary": // 询价单
        this.rulesItem = ["SN", "型号"];
        this.importantMessage = "如果只有一列型号，请确认没有空数据。";
        this.linkMessage = "";
        break;
      case "updateInquirySheet": // 维护询价单
        this.rulesItem = [];
        this.importantMessage =
          "此页面不用选择，直接点击保存；请在询价单管理点击匹配";
        this.linkMessage = "";
        break;
      case "quoteLibrary": // 报价库
        this.rulesItem = ["SN", "型号", "华强品名", "ProductName", "单价类型"];
        this.importantMessage =
          "单价类型代码：无价格——0   通用价格——1    特殊客人价——2 单价类型是1或者2的，采购单价/报价供应商/销售单价必填；报价供应商为供应商编号";
        this.linkMessage = "";
        break;
      case "orderLibrary": // 下单库
        this.rulesItem = [
          "SN",
          "型号",
          "华强品名",
          "采购单价",
          "报价供应商",
          "销售单价",
          "单价类型",
          "ProductName",
        ];
        this.importantMessage =
          "1. 单价类型不能填写0；2. 必选项的内容不能为空；3. 报价供应商为供应商编号；4.产品描述不超过200个字。";
        this.linkMessage = "5. 点击查看上传套件产品注意事项";
        break;
      case "claimForm": // 索赔单
        this.rulesItem = ["SN", "型号"];
        this.importantMessage =
          "下载的结果如果要上传生成索赔单，请在CN单据中上传，并填写好以下信息：数量（索赔数量）、索赔预期、备注";
        this.linkMessage = "";
        break;
      default:
        this.rulesItem = [];
        this.importantMessage = "";
        this.linkMessage = "";
    }
  }

  private async customerName() {
    let customerAbbreviation =
      (this.$route.query.customerAbbreviation as string) || "";
    let customerId = (this.$route.query.customerId as string) || "";
    if (customerAbbreviation && customerId) {
      await this.searchCustomers(customerAbbreviation);
      this.payload.customerId = customerId;
    }
  }

  private addResult(value, item, index) {
    // 获取headCascader的选中节点
    let nodes = (
      this.$refs[`headCascader${index}`] as any
    )[0].getCheckedNodes();
    console.log("------------------------------------------------", nodes);
    // console.log(nodes[0].data);
    if (nodes.length > 0) {
      let header = {
        headerName: item,
        name: nodes[0].data.value,
        status: nodes[0].data.type,
      };
      console.log(header);
      this.resultHeaderList[index] = header;
      this.headerMap.set(item, value);
    } else {
      this.resultHeaderList.splice(index, 1);
      this.headerMap.set(item, value);
      return;
    }
  }

  private selectChange(e) {
    if (e === "claimForm") {
      this.getClaimFormCNCode();
    }
    this.assignmentOfMessage();
  }

  remarkSave() {
    this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
    // this.saveProductNumberExtends = status
  }

  private saveProductNumberExtendsChange(e) {
    if(!e) {
      this.clearProductNumberExtends = false;
    }
  }

  private async saveAndSend() {
    this.saveButtonDisabled = true;
    let list = this.resultHeaderList.filter((item) => item != null);
    const info: any = await queryTaskInfo(this.taskId);
    if (info.state != "CREATE" && info.state != "ERROR") {
      this.$notify({
        title: "ERROR",
        message: "该任务正在执行或者已完成，无法进行保存",
        type: "error",
        duration: 2000,
      });
      this.saveButtonDisabled = false;
      return;
    }
    console.log("保存的list", list);
    this.checkArray(list);
    if (this.checkArray(list)) {
      this.$notify({
        title: "ERROR",
        message: "表头不允许重复",
        type: "error",
        duration: 2000,
      });
      this.saveButtonDisabled = false;
      return;
    }
    if(!this.payload.customerId) {
      this.$notify({
        title: "提示",
        message: "客户未选择",
        type: "error",
        duration: 2000
      });
      return
    }
    let params = {
      list,
      taskId: this.taskId,
      saveProductNumberExtends: this.saveProductNumberExtends,
      clearProductNumberExtends: this.clearProductNumberExtends,
      accountTypeByOperation: this.accountTypeByOperation
    };
    if (this.payload.type === "claimForm") {
      this.$confirm(
        "匹配将会根据最新的PI检索范围重新生成匹配结果，且只会保留最后的匹配结果，是否继续操作",
        "匹配",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await saveRFQ(params).then(() => {
            this.$notify({
              title: "成功",
              message: "添加队列成功",
              type: "success",
              duration: 2000,
            });
            this.saveButtonDisabled = false;
          });
        })
        .catch((err) => {
          console.error(err);
          this.saveButtonDisabled = false;
        });
    } else if(this.payload.type === 'inquiryLibrary') {
      this.$confirm("1、上传维护修改品名，会重置产品价格，请注意核对\n2、上传结果去询价单列表的维护状态查看", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(async () => {
        await saveRFQ(params).then(() => {
          this.$notify({
            title: "成功",
            message: "添加队列成功",
            type: "success",
            duration: 2000
          });
    this.saveButtonDisabled = false;
        });
      })
      .catch((err) => {
        console.error(err);
    this.saveButtonDisabled = false;
      });
    } else if(this.payload.type === 'updateInquirySheet') {
      this.$confirm("上传结果去询价单列表的维护状态查看", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(async () => {
        await saveRFQ(params).then(() => {
          this.$notify({
            title: "成功",
            message: "添加队列成功",
            type: "success",
            duration: 2000
          });
    this.saveButtonDisabled = false;
        });
      })
      .catch((err) => {
        console.error(err);
    this.saveButtonDisabled = false;
      });
    } else {
      await saveRFQ(params).then(() => {
        this.$notify({
          title: "成功",
          message: "添加队列成功",
          type: "success",
          duration: 2000,
        });
        this.saveButtonDisabled = false;
      });
    }
    // inquiryLibrary 上传询价单
    // updateInquirySheet 重新上传询价单
  }

  private async getClaimFormCNCode() {
    const res: any = await getClaimFormCNCode();
    this.CNCode = res.map((item) => {
      return {
        value: item.id,
        label: item.code,
      };
    });
  }

  private checkArray(array) {
    // 虽然很蠢，但也只能这样了。。。
    for (let k = 0; k < array.length; k++) {
      for (let n = k + 1; n < array.length; n++) {
        if (array[k].name == array[n].name) return true;
      }
    }
    return false;
  }

  private strMapToObj(strMap) {
    let obj = Object.create(null);
    for (let [k, v] of strMap) {
      obj[k] = v;
    }
    return obj;
  }

  private addFile(file: any) {
    if (file.size / 1024 / 1024 >= 10) {
      Message({
        message: "上传的文件大小不能超过10M!",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.files.push(file);
  }

  private searchCustomers(a) {
    this.isSearchingCustomers = true;
    searchCustomer({ keyword: a })
      .then((res: any) => {
        this.customers = res;
        this.isSearchingCustomers = false;
      })
      .catch(() => {
        this.isSearchingCustomers = false;
      });
  }

  private async getTableHeaderList(value: string) {
    if (value === "inquiryLibrary") {
      return getInquirySheetTableHeader();
    }
    if (value === "updateInquirySheet") {
      return updateInquirySheetTableHeader(this.accountTypeByOperation);
    }
    if (value === "quoteLibrary") {
      return getQuoteLibraryTableHeader();
    }
    if (value === "orderLibrary") {
      return getOrderLibraryTableHeader();
    }
    if (value === "claimForm") {
      return getCNTableHeader();
    }
  }

  private async handleUpload() {
    if (this.payload.type === "") {
      this.$notify({
        title: "提示",
        message: "请先选择单据类型",
        type: "error",
        duration: 2000,
      });
      return;
    }
    if (this.files.length == 0) {
      return;
    }
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    formData.append("type", this.payload.type);
    // if (
    //   this.payload.type === "orderLibrary" ||
    //   this.payload.type === "quoteLibrary" ||
    //   this.payload.type == "inquiryLibrary"
    // ) {
    //   formData.append(
    //     "saveProductNumberExtends",
    //     this.saveProductNumberExtends as any
    //   );
    //   formData.append(
    //     "clearProductNumberExtends",
    //     this.clearProductNumberExtends as any
    //   );
    // }
    // if (this.$route.query.customerId) {
    //   formData.append("customerId", (this.$route.query.customerId) as string || "");
    // } else {
    //   formData.append("customerId", this.payload.customerId);
    // }
    if (this.payload.IVterm === "") {
      this.payload.IVterm = "noLimit";
    }
    if (this.payload.PIterm === "") {
      this.payload.PIterm = "noLimit";
    }
    if (this.payload.type === "claimForm") {
      // 判断选择类型是否为索赔单 添加IV期限和PI期限
      formData.append("ivTerm", this.payload.IVterm);
      formData.append("piTerm", this.payload.PIterm);
    }
    formData.append("customerId", this.payload.customerId || "");
    formData.append("resourceId", (this.$route.query.id as string) || "");
    if (this.payload.type === "updateInquirySheet") {
      formData.append("accountTypeByOperation", this.accountTypeByOperation);
    }
    this.headerList = (await this.getTableHeaderList(this.payload.type)) as any;
    await uploadDynamicsExcel(
      this.payload.type === "updateInquirySheet" ? this.payload.replace : "",
      formData
    ).then((result: any) => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.taskId = result.taskId;
      this.chooseHeader = result.chooseHeader;
      this.dataHeader = result.headerData;
      this.realHeader = this.dataHeader.header;
      this.unique(this.realHeader);
      const data = this.dataHeader.data;
      let row: any = new RowData();
      for (let i = 0; i < data.length; i++) {
        // this.dataHeader.readHeader.push("");
        ({ [i]: row[i] } = { [i]: data[i] });
      }
      this.rowData = [row]; // 直等
      // this.rowData.push(row); // 添加
      this.getRequestHeader();
    });
    this.files = [];
  }

  private getRequestHeader() {
    this.realHeader.forEach((item, index) => {
      let matchedItem = null;
      let requestHeader = null;
      this.chooseHeader.forEach((item2) => {
        if (item === item2.label) {
          matchedItem = {
            headerName: item2.label,
            name: item2.value[item2.value.length - 1],
            status: item2.type,
          };
          requestHeader = item2.value;
        }
      });
      if (matchedItem) {
        // 只保留最后一个匹配项
        this.resultHeaderList[index] = matchedItem;
        this.requestHeader[index] = requestHeader;
      }
    });
  }

  private showClickMessage = false;

  private clickMessage() {
    this.showClickMessage = true;
  }

  private unique(arr) {
    for (var i = 0; i < arr.length; i++) {
      for (var j = i + 1; j < arr.length; j++) {
        if (arr[i] == arr[j]) {
          //第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }
}

class TableHeadler {
  data: string[];
  header: string[];
}

class RowData {
  [key: string]: any;
}
